import usePatientOrdersActions from '../hooks/usePatientOrdersActions';

import {
  ColumnData,
  DateFilter,
  OrderTypeProps,
  PatientOrderHookReturn,
  PatientOrdreOrderProductProps,
} from '../interface/interface';
import { Search } from '../components/Search';
import CustomMonthDatePicker from '../components/CustomMonthDatePicker';
import { Table } from '../components/Table';
import moment from 'moment';
import { AlertIcon } from '../assets/svgImages';
import { Tooltip } from 'react-tooltip';
import { useCallback } from 'react';

export default function PatientOrders() {
  const [
    loading,
    total,
    tableData,
    search,
    monthFilterProps,
  ]: PatientOrderHookReturn = usePatientOrdersActions();

  const handleDateRangeChange = useCallback(
    (range: [DateFilter, DateFilter]) => {
      monthFilterProps.setMonthRange(range);
    },
    [monthFilterProps],
  );

  const columns: Array<ColumnData> = [
    {
      key: 'invoiceId',
      header: () => 'Order ID',
      isSortable: true,
      width: '10%',
      cell: (info) => info.getValue(),
    },
    {
      key: 'createdDate',
      header: () => 'Ordered Date',
      isSortable: true,
      width: '1%',
      cell: (info) => {
        const date = moment(info.getValue());
        return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : '-';
      },
    },
    {
      key: 'orderProductDetailsQty',
      header: () => 'Qty',
      width: '1%',
      cell: (info) => {
        return (
          <div>
            {info?.row?.original?.orderProductDetails?.map(
              (ele: PatientOrdreOrderProductProps, index: number) => (
                <p key={index + 1} className="mb-2">
                  {ele.orderQty}
                </p>
              ),
            )}
          </div>
        );
      },
    },
    {
      key: 'orderProductDetails',
      header: () => 'Product Name',
      width: '34%',
      cell: (info) => {
        const orderProductDetails = info.row.original.orderProductDetails || [];
        const invoiceId = info.row.original.invoiceId;
        return (
          <div>
            {orderProductDetails.map(
              (ele: PatientOrdreOrderProductProps, index: number) => (
                <p key={index + 1} className="mb-2">
                  {ele.orderProduct}
                  {ele.isSubsitutate && (
                    <p className="ml-5">
                      {' '}
                      <a data-tooltip-id={invoiceId}>
                        <AlertIcon className="absolute left-6 fill-secondary-pink-500 cursor-pointer" />
                      </a>
                      <Tooltip className="z-[200]" id={invoiceId}>
                        <p>Substitute Product</p>
                      </Tooltip>
                      {ele.substituteProduct}
                    </p>
                  )}
                </p>
              ),
            )}
          </div>
        );
      },
    },
    {
      key: 'shippingAddress',
      header: () => 'Shipping Addresss',
      isSortable: true,
      width: '34%',
      cell: (info) => {
        const shippingAddress = info.row.original?.shippingAddress;
        {
          if (
            shippingAddress.first_name ||
            shippingAddress.last_name ||
            shippingAddress.address1 ||
            shippingAddress.address2 ||
            shippingAddress.city ||
            shippingAddress.zip ||
            shippingAddress.province
          ) {
            return (
              <div>
                <p className="mb-2">
                  {`${shippingAddress.first_name ?? ''} ${shippingAddress.last_name},`}
                  <br />
                  {`${shippingAddress.address1}, 
              ${shippingAddress.address2 ? `${shippingAddress.address2},` : ''}`}
                  <br />
                  {`${shippingAddress.city} ,
                ${shippingAddress.zip} , ${shippingAddress.province} ,
                Australia.`}
                </p>
              </div>
            );
          }
          return '-';
        }
      },
    },
    {
      key: 'orderStatus',
      header: () => 'Order Status',
      cell: (info) => info.getValue(),
      width: '10%',
    },
  ];

  return (
    <>
      <div className="flex flex-wrap items-center justify-between">
        <div className="tab mr-2 2xl:mr-4 pb-1 font-semibold cursor-pointer  active text-primary-blue-500 text-xl 2xl:text-2xl">
          Total Orders :{' '}
          {loading ? (
            <span className="loader"></span>
          ) : (
            <span className="text-xl font-semibold">{total}</span>
          )}
        </div>
        <div className="flex flex-wrap items-center justify-between">
          <div className="mr-4">
            <CustomMonthDatePicker
              monthRange={monthFilterProps.monthRange}
              onMonthChange={handleDateRangeChange}
              restrict={6}
            />
          </div>
          <div className="border rounded-md border-primary-blue-500 ">
            <Search
              value={search.value}
              changeHandler={search.changeHandler}
              submitSearch={search.submitSearch}
            />
          </div>
        </div>
      </div>
      {tableData?.length ? (
        <div className="mt-10">
          <Table
            columns={columns}
            data={tableData}
            enableSorting={true}
            childLoader={loading}
            order={OrderTypeProps.DOCTOR}
          />
        </div>
      ) : (
        <p className="font-semibold text-primary-blue-500 text-center text-xl">
          {' '}
          No Order Exist
        </p>
      )}
    </>
  );
}
